export enum IconEnum {
  Back = 'arrow-right',
  Support = 'headphone',
  Home = 'home',
  Car = 'car',
  Close = 'close',
  Search = 'search',
  Remove = 'remove',
  Warn = 'warn',
  WarningAlert = 'warning-alert',
  Digipay = 'digipay',
  More = 'more',
  ArrowLeftCircleBlue = 'arrow-left-circle-blue',
  GuideBlue = 'guide-blue',
  Guide = 'info-circle',
  NoPlate = 'no-plate',
  EditBlue = 'edit-blue',
  DefaultCar = 'default-car',
  DriverDiscount = 'driver-discount',
  ThirdPartyDiscount = 'third-party-discount',
  InfoBlueCircle = 'info-blue-circle',
  EmptyInsurance = 'empty-insurance',
  RadioButton = 'radio-button',
  RadioButtonActive = 'radio-button-active',
  RadioButtonDisabled = 'radio-button-disabled',
  CarBlue = 'car-blue',
  CloseBlue = 'close-blue',
  UmbrellaGray = 'umbrella-gray',
  Filter = 'filter',
  FilterBlue = 'filter-blue',
  Sort = 'sort',
  SortBlue = 'sort-blue',
  CheckboxEmpty = 'checkbox-empty',
  CheckboxFill = 'checkbox-fill',
  NotFoundFilterBgWhite = 'not-found-filter-bg-white',
  NotFoundFilterBgGray = 'not-found-filter-bg-gray',
  Error = 'error',
  RetryBlue = 'retry-blue',
  Compare = 'compare',
  CompareNewDesign = 'compare-new-design',
  BNPL = 'bnpl',
  BNPLNewDesign = 'bnpl-new-design',
  BNPLWhite = 'bnpl-white',
  BottomChevronDarkGray = 'bottom-chevron-dark-gray',
  WarningYellowTriangle = 'warning-yellow-triangle',
  ArrowDownBlack = 'arrow-down-black',
  InfoBlue = 'info-blue',
  GiftYellow = 'gift-yellow',
  PercentBlue = 'percent-blue',
  PercentPurple = 'percent-purple',
  UmbrellaColorFully = 'umbrella-colorfully',
  WarningGreenTriangle = 'warning-green-triangle',
  WarningRedTriangle = 'warning-red-triangle',
  InfoSquare = 'info-square',
  StartYellow = 'star-yellow',
  ArrowedCalendarWhite = 'arrowed-calendar-white',
  WarningYellowCircle = 'warning-yellow-circle',
  Bullet = 'bullet',
  BulletTitle = 'bullet-title',
  Success = 'success',
  HintBlue = 'hint-blue',
  HintRed = 'hint-red',
  BNPLCurve = 'bnpl-curve',
  Add = 'add',
  Voucher = 'voucher',
  Avatar = 'avatar',
  Comment = 'comment',
  EmailBlue = 'email-blue',
  ArrowCircleGray = 'arrow-circle-gray',
  Warning = 'warning',
  CalendarBlue = 'calendar-blue',
  PercentCircleBlack = 'percent-circle-black',
  ThirdParty = 'third-party',
  Body = 'body',
  Equipment = 'equipment',
  HeartPurple = 'heart-purple',
  GiftCircleBackGray = 'gift-circle-back-gray',
  RenewalCircleBackGray = 'renewal-circle-back-gray',
  ArrowLeftCircleBackBlue = 'arrow-left-circle-back-blue',
  PercentCircleBackWhite = 'percent-circle-back-white',
  WarningWhite = 'warning-white',
  ErrorCircle = 'error-circle',
  Claim = 'claim',
  ErrorLowCredit = 'error-low-credit',
  Insurance = 'insurance',
  BankCard = 'bank-card',
  BnplCard = 'bnpl-card',
  Rocket = 'rocket',
  BnplDue = 'bnpl-due',
  TicketWhite = 'ticket-white'
}
